define('models/list-state',["exports", "underscore", "backbone", "common"], function (_exports, _underscore, _backbone, _common) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _default = _exports.default = _backbone.Model.extend({
    parseQuery() {
      this.set(this.parseLocation(), {
        initial: true
      });
      this.backFilter({
        initial: true
      });
    },
    updateBudgetLimits(m, v, options) {
      if (options.initial) {
        return;
      }
      var change = this.budgetLimits(this.get('currency'));
      if (change) {
        if (this.attributes._budget$max) {
          change.budget$start = Math.floor(this.attributes.budget$start * change._budget$max / this.attributes._budget$max / change._budget$step) * change._budget$step;
          change.budget$end = Math.floor(this.attributes.budget$end * change._budget$max / this.attributes._budget$max / change._budget$step) * change._budget$step;
        }
        this.set(change, options);
      }
    },
    async updateQuantity(prop) {
      var update = (change, key, value) => {
        change[`qty$${key}`] = value;
        change[`dis$${key}`] = !(value || this.get(key));
      };
      var _this$getLocation = this.getLocation(),
        path = _this$getLocation.path,
        params = _this$getLocation.params;
      var query = new URLSearchParams(params.toString());
      query.set('field', prop);
      query.set('path', path);
      var data = await (0, _common.getJSON)(`${this.getStatPath()}?${query}`);
      var change = {};
      (0, _underscore.each)(this.attributes, (value, key) => {
        if (/^(qty|dis)\$/.test(key)) {
          var _data$key;
          key = key.substring(4);
          update(change, key, (_data$key = data[key]) !== null && _data$key !== void 0 ? _data$key : null);
        }
      });
      (0, _underscore.each)(data, (value, key) => update(change, key, value));
      this.set(change, {
        quantity: true
      });
    },
    _groupBoolAttribute(change, attr, it = _underscore.identity) {
      var keys = (0, _underscore.chain)(this.attributes).reduce((acc, value, key) => {
        if (value && key.indexOf(attr) === 0 && key[attr.length] === '$') {
          acc.push(it(key.substring(attr.length + 1)));
        }
        return acc;
      }, []).sortBy().value();
      change[attr] = keys.length ? keys : null;
      return change;
    },
    _ungroupBoolAttribute(attr, it = _underscore.identity) {
      var change = {};
      var arr = this.attributes[attr];
      (0, _underscore.chain)(this.attributes).reduce((acc, value, key) => {
        if (value && key.indexOf(attr) === 0 && key[attr.length] === '$') {
          acc[key] = (0, _underscore.contains)(arr, it(key.substring(attr.length + 1)));
        }
        return acc;
      }, change);
      return (0, _underscore.reduce)(arr, (acc, value) => {
        acc[`${attr}$${value}`] = true;
        return acc;
      }, change);
    }
  });
});//# sourceMappingURL=list-state.js.map
;
